import _ from "lodash";
import { Client } from "../../theming/ThemeProvider";
import { THEME } from "../../theming/theming";
export var PORTAL_TABLE_STYLES = {
    body: {
        borderBottom: { width: 0 },
        borderLeft: { width: 0 },
        borderRight: { width: 0 },
        borderRadiusBottomLeft: 4,
        borderRadiusBottomRight: 4,
        oddRow: {
            backgroundColor: "#fff",
            borderBottom: {
                color: "#edf2f5",
            },
        },
        evenRow: {
            backgroundColor: "#fff",
            borderBottom: {
                color: "#edf2f5",
            },
        },
    },
    header: {
        borderTop: { width: 0 },
        borderRight: { width: 0 },
        borderLeft: { width: 0 },
        borderBottom: { width: 1, color: THEME.palette.gray.smoke.color },
        separator: { width: 0 },
        backgroundColor: "#fff",
        color: THEME.palette.gray.slate.color,
        fontWeight: 700,
        fontSize: 11,
        textTransform: "uppercase",
    },
};
export var SUBDUED_TABLE_STYLES = {
    body: {
        borderLeft: {
            color: THEME.palette.gray.smoke.color,
        },
        borderRight: {
            color: THEME.palette.gray.smoke.color,
        },
        borderBottom: {
            color: THEME.palette.gray.smoke.color,
        },
        oddRow: {
            borderBottom: {
                color: "#edf2f5",
            },
            backgroundColor: THEME.palette.gray.fog.color,
            backgroundHoverColor: THEME.palette.gray.mist.color,
        },
        evenRow: {
            borderBottom: {
                color: "#edf2f5",
            },
            backgroundColor: THEME.palette.gray.fog.color,
            backgroundHoverColor: THEME.palette.gray.mist.color,
        },
    },
    header: {
        borderTop: { width: 0 },
        borderBottom: { width: 0 },
        borderLeft: { width: 0 },
        borderRight: { width: 0 },
        separator: { width: 0 },
        color: THEME.palette.gray.smoke.contrast,
        backgroundColor: THEME.palette.gray.smoke.color,
        backgroundColorHover: THEME.palette.gray.silver.color,
    },
};
export var DEFAULT_TABLE_STYLES = {
    body: {
        borderLeft: {
            width: 1,
            style: "solid",
            color: THEME.palette.gray.smoke.color,
        },
        borderRight: {
            width: 1,
            style: "solid",
            color: THEME.palette.gray.smoke.color,
        },
        borderBottom: {
            width: 1,
            style: "solid",
            color: THEME.palette.gray.smoke.color,
        },
        oddRow: {
            borderBottom: {
                width: 1,
                style: "solid",
                color: THEME.palette.gray.smoke.color,
            },
            backgroundColor: THEME.palette.gray.fog.color,
            backgroundHoverColor: THEME.palette.gray.fog.color,
        },
        evenRow: {
            borderBottom: {
                width: 1,
                style: "solid",
                color: THEME.palette.gray.smoke.color,
            },
            backgroundColor: THEME.palette.gray.white.color,
            backgroundHoverColor: THEME.palette.gray.fog.color,
        },
        borderRadiusBottomLeft: 0,
        borderRadiusBottomRight: 0,
    },
    header: {
        borderTop: {
            width: 1,
            style: "solid",
            color: THEME.palette.primary.dark.color,
        },
        borderBottom: {
            width: 1,
            style: "solid",
            color: THEME.palette.primary.dark.color,
        },
        borderLeft: {
            width: 1,
            style: "solid",
            color: THEME.palette.primary.dark.color,
        },
        borderRight: {
            width: 1,
            style: "solid",
            color: THEME.palette.primary.dark.color,
        },
        separator: {
            width: 1,
            style: "solid",
            color: THEME.palette.primary.dark.color,
        },
        color: THEME.palette.primary.base.contrast,
        backgroundColor: THEME.palette.primary.base.color,
        backgroundColorHover: THEME.palette.primary.dark.color,
        fontWeight: 400,
        fontSize: 14,
        textTransform: "none",
    },
};
export function getTableStyles(theme, styling, childTable, client) {
    if (childTable) {
        styling = "subdued";
    }
    switch (styling) {
        case "subdued":
            return _.merge({}, DEFAULT_TABLE_STYLES, SUBDUED_TABLE_STYLES);
        case "branded":
            return _.merge({}, DEFAULT_TABLE_STYLES, theme);
        case "default":
        default:
            if (client === Client.Portal) {
                return _.merge({}, DEFAULT_TABLE_STYLES, PORTAL_TABLE_STYLES);
            }
            return _.merge({}, DEFAULT_TABLE_STYLES);
    }
}
export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}
